export default "__VITE_ASSET__BgywKOdj__"